// Saga action types
export const HANDLE_ERROR = '@global/HANDLE_ERROR';

// All Types and Interfaces of store module
export interface GlobalState {
  loading: { [key: string]: boolean };
  errors: { [key: string]: string };
}
